import { render, staticRenderFns } from "./USC_21_012.vue?vue&type=template&id=68ca90e6"
import script from "./USC_21_012.vue?vue&type=script&lang=js"
export * from "./USC_21_012.vue?vue&type=script&lang=js"
import style0 from "./USC_21_012.vue?vue&type=style&index=0&id=68ca90e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports